<template>
  <div class="page-content super-admin-device">
    <h1 class="page-title">{{ $locale('sideMenu.settings.devicesManagement') }}</h1>

    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col class="makeInline" :lg="12" :md="18">
        <el-input
          placeholder="hardwareId"
          v-model="filter.hardwareId"
          @keyup.enter.native="searchDevice"
          class="search-max-width"
          data-testid="hardware-id-search-input"
        >
          <i slot="suffix" class="el-input__icon el-icon-search" @click="searchDevice"></i>
        </el-input>
        <el-button class="egl-btn-yellow make-left" @click="searchDevice" data-testid="search-btn">
          {{ $locale("global.search") }}
        </el-button>
      </el-col>
    </el-row>

    <!-- Device Table -->
    <el-table :data="deviceTable" class="egl-table list-table" stripe data-testid="device-table">
      <el-table-column :label="$locale('global.change')" width="70" align="center">
        <template slot-scope="scope">
          <i class="el-icon-circle-check change" v-if="!scope.row.isApprove"></i>
        </template>
      </el-table-column>

      <el-table-column
        v-for="th in deviceThead"
        :label="th.text"
        :prop="th.prop"
        :key="th.prop"
        :align="th.align"
        :width="th.width"
      ></el-table-column>

      <el-table-column :label="$locale('global.control')" align="center" width="120">
        <template slot-scope="scope">
          <div class="handle">
            <a @click="editDevice(scope.row)" data-testid="edit-device-btn">{{ $locale("global.edit") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="ta-r">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-count="pageCount"
        @current-change="choosePage"
        :current-page="page"
        data-testid="device-pagination"
      ></el-pagination>
    </div>

    <!-- Edit Dialog -->
    <el-dialog
      :visible="editDialogVisible"
      width="600px"
      :show-close="true"
      class="egl-dialog-elm"
      :title="$locale('global.edit')"
      @close="closeEditDialog"
      :close-on-click-modal="false"
      data-testid="edit-device-dialog"
    >
      <el-form ref="editForm" :model="editForm" label-position="top">
        <el-form-item :label="$locale('global.name')" class="name-input">
          <div class="form-text">{{ editForm.name }}</div>
        </el-form-item>
        <el-form-item label="劇場名" class="name-input">
          <div class="form-text">{{ editForm.cinemaName }}</div>
        </el-form-item>
        <el-form-item :label="$locale('setting.device.devicetype')" class="device-type">
          <div class="form-text">{{ editForm.deviceType }}</div>
        </el-form-item>
        <el-form-item label="デバイスSN" class="name-input">
          <el-input v-model="editForm.hardwareId" clearable data-testid="edit-devicesecret-input"></el-input>
        </el-form-item>
        <el-form-item label="HardwareId" class="name-input">
          <el-input v-model="editForm.hardwareId" clearable data-testid="edit-hardwareid-input"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-button class="egl-btn-white" @click="closeEditDialog" data-testid="cancel-edit-btn">
              {{ $locale("global.cancel") }}
            </el-button>
            <el-button class="egl-btn-yellow" @click="saveEdit" data-testid="confirm-edit-btn">
              {{ $locale("global.confirm") }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDeviceList, updateDevice } from "@/helpers/service/api/device.js";

export default {
  name: "super-admin-device-list",
  data() {
    return {
      deviceTable: [],
      deviceThead: [],
      filter: {
        hardwareId: "",
      },
      page: 1,
      pageCount: 1,
      editDialogVisible: false,
      editRowFull: {},
      editForm: {
        id: "",
        cinemaName: "",
        name: "",
        deviceType: "",
        hardwareId: "",
        deviceSecret: "",
      },
    };
  },
  methods: {
    createDeviceThead() {
      return [
        {
          prop: "cinemaName",
          text: "劇場名",
          width: 200,
        },
        {
          prop: "name",
          text: this.$locale("global.name"),
          width: 200,
        },
        {
          prop: "deviceType",
          text: this.$locale("setting.device.devicetype"),
          align: "center",
        },
        {
          prop: "hardwareId",
          text: "hardwareId",
          width: 260,
        },
        {
          prop: "hardwareId",
          text: "デバイスSN",
          width: 260,
        },
        {
          prop: "status",
          text: this.$locale("global.status"),
          align: "center",
          width: 100,
        },
      ];
    },
    getDeviceListFn() {
      let obj = {
        page: this.page - 1,
        pageSize: 10,
        isPage: true,
      };
      if (this.filter.hardwareId) {
        obj.hardwareId = this.filter.hardwareId;
      }
      return getDeviceList(obj, false, false);
    },
    searchDevice() {
      this.page = 1;
      this.loadDeviceTable();
    },
    choosePage(page) {
      this.page = page;
      this.loadDeviceTable();
    },
    loadDeviceTable() {
      this.getDeviceListFn().then((res) => {
        if (res.success) {
          this.deviceTable = res.data.data || [];
          this.pageCount = Math.ceil(res.data.count / 10);
        } else {
          this.$alert(res.message, { showClose: false });
        }
      }).catch(() => {});
    },
    editDevice(row) {
      this.editRowFull = { ...row };
      this.editForm = {
        id: row.id,
        cinemaName: row.cinemaName || "",
        name: row.name || "",
        deviceType: row.deviceType || "",
        hardwareId: row.hardwareId || "",
        deviceSecret: row.deviceSecret || "",
      };
      this.editDialogVisible = true;
    },
    closeEditDialog() {
      this.editDialogVisible = false;
      this.$refs.editForm.resetFields();
    },
    saveEdit() {
      updateDevice({
        deviceInfo: {
          ...this.editRowFull,
          hardwareId: this.editForm.hardwareId,
          deviceSecret: this.editForm.deviceSecret,
        },
      }).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: this.$locale("global.updateSuccessfully"),
          });
          this.editDialogVisible = false;
          this.loadDeviceTable();
        } else {
          this.$alert(res.message, { showClose: false });
        }
      }).catch(() => {});
    },
  },
  created() {
    this.deviceThead = this.createDeviceThead();
    this.loadDeviceTable();
  },
};
</script>

<style scoped>
.search-area {
  margin-bottom: 20px;
}
.makeInline {
  white-space: nowrap;
}
.search-max-width {
  max-width: 350px;
}
.make-left {
  margin-left: 10px;
}
.form-text {
  padding-top: 9px;
  line-height: 1.5;
  color: #606266;
}
</style>